import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

export interface ScheduleSlot {
  id: string;
  taskId: string;
  personId: string;
  personName: string;
  date: string;
  startTime: string;
  endTime: string;
  durationMinutes: number;
  partNumber: string;
  laborBucket: string;
  status: string;
  gpSalesOrderNumber: string;
}

interface SlotsResponse {
  data: ScheduleSlot[];
  scheduleVersion: number;
}

export function useScheduleSlots(startDate: string, endDate: string, personId?: string) {
  return useQuery({
    queryKey: ['schedule-slots', startDate, endDate, personId],
    queryFn: async (): Promise<SlotsResponse> => {
      const params = new URLSearchParams({ startDate, endDate });
      if (personId) params.set('personId', personId);
      return apiFetch<SlotsResponse>(`/api/v1/schedule/slots?${params}`);
    },
    enabled: !!startDate && !!endDate,
    staleTime: 30000,
  });
}
